var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "mb-2" }, [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "grid-x grid-margin-x grid-margin-y py-2 px-2" },
          [
            _c(
              "div",
              { staticClass: "cell medium-6 xlarge-8" },
              [
                _c("label", [_vm._v("Requisitions")]),
                _vm._v(" "),
                _c("vue-select", {
                  attrs: { options: _vm.requisitions, filterable: false },
                  on: {
                    search: _vm.fetchRequisitions,
                    open: _vm.fetchRequisitions
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function(option) {
                        return [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.requisitionTitle(option)) +
                              "\n                        "
                          )
                        ]
                      }
                    },
                    {
                      key: "selected-option",
                      fn: function(option) {
                        return [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.selectedRequisitionTitle(option)) +
                              "\n                        "
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.filterParams.requisition,
                    callback: function($$v) {
                      _vm.$set(_vm.filterParams, "requisition", $$v)
                    },
                    expression: "filterParams.requisition"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cell medium-6 xlarge-2" },
              [
                _c("label", [_vm._v("Verification Type")]),
                _vm._v(" "),
                _c("vue-select", {
                  attrs: { label: "title", options: _vm.verificationTypes },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function(option) {
                        return [
                          _vm._v(
                            "\n                            " +
                              _vm._s(option.title) +
                              "\n                        "
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.filterParams.verification_type,
                    callback: function($$v) {
                      _vm.$set(_vm.filterParams, "verification_type", $$v)
                    },
                    expression: "filterParams.verification_type"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "cell medium-6 xlarge-2" },
              [
                _c("label", [_vm._v("Status")]),
                _vm._v(" "),
                _c("vue-select", {
                  attrs: { label: "title", options: _vm.statuses },
                  scopedSlots: _vm._u([
                    {
                      key: "option",
                      fn: function(option) {
                        return [
                          _vm._v(
                            "\n                            " +
                              _vm._s(option.title) +
                              "\n                        "
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.filterParams.status,
                    callback: function($$v) {
                      _vm.$set(_vm.filterParams, "status", $$v)
                    },
                    expression: "filterParams.status"
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "grid-x grid-margin-x grid-margin-y py-2 px-2" },
          [
            _c("div", { staticClass: "cell small-6 medium-4 xlarge-4" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "count-card" }, [
                  _c("span", { staticClass: "count-number" }, [
                    _vm._v(_vm._s(_vm.summary.in_progress))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "count-name" }, [
                    _vm._v("In Progress")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell small-6 medium-4 xlarge-4" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "count-card" }, [
                  _c("span", { staticClass: "count-number" }, [
                    _vm._v(_vm._s(_vm.summary.completed))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "count-name" }, [
                    _vm._v("Completed")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell small-6 medium-4 xlarge-4" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "count-card" }, [
                  _c("span", { staticClass: "count-number" }, [
                    _vm._v(_vm._s(_vm.summary.failed))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "count-name" }, [_vm._v("Failed")])
                ])
              ])
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "mt-2" }, [
      _c("div", [
        _c("div", { staticClass: "grid-x grid-margin-x grid-margin-y" }, [
          _c(
            "div",
            { staticClass: "cell small-6 medium-4 medium-offset-8 offset-6" },
            [
              _c("div", { staticClass: "card p-2" }, [
                _c("div", { staticClass: "grid-x grid-margin-x" }, [
                  _c("div", { staticClass: "cell small-6" }, [
                    _c("label", [_vm._v("From")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filterParams.date_from,
                          expression: "filterParams.date_from"
                        }
                      ],
                      staticClass: "m-0",
                      attrs: { type: "date" },
                      domProps: { value: _vm.filterParams.date_from },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.filterParams,
                            "date_from",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell small-6" }, [
                    _c("label", [_vm._v("To")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.filterParams.date_to,
                          expression: "filterParams.date_to"
                        }
                      ],
                      staticClass: "m-0",
                      attrs: { type: "date" },
                      domProps: { value: _vm.filterParams.date_to },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.filterParams,
                            "date_to",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell small-12" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-success mt-2 w-full",
                        attrs: {
                          href: _vm.candidateDashboardExportUrl,
                          target: "_blank"
                        }
                      },
                      [_vm._v("Download")]
                    )
                  ])
                ])
              ])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", [
      _vm.isLoading
        ? _c("div", { staticClass: "spinner" }, [
            _c("i", { staticClass: "fa fa-solid fa-spinner fa-spin" }),
            _vm._v(" Loading....\n        ")
          ])
        : _c(
            "div",
            {
              staticClass:
                "requisitions-table grid-x grid-padding-x grid-padding-y py-2"
            },
            [
              _c(
                "div",
                { staticClass: "cell small-12" },
                [
                  _c(
                    "div",
                    { staticClass: "grid-x grid-padding-x grid-padding-y" },
                    [
                      _c(
                        "div",
                        { staticClass: "cell small-8" },
                        [
                          _c("Pagination", {
                            attrs: {
                              totalPages: _vm.totalPages,
                              currentPage: _vm.currentPage,
                              maxPagesToShow: 10
                            },
                            on: { "page-changed": _vm.handlePageChange }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell small-4 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            on: { click: _vm.clearFilter }
                          },
                          [_vm._v("Clear Filter")]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.backgroundVerificationResults, function(
                        backgroundVerificationResult
                      ) {
                        return _c(
                          "tr",
                          { key: backgroundVerificationResult.id },
                          [
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.requisitionTitleTable(
                                      backgroundVerificationResult
                                        .job_application.job
                                    )
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    backgroundVerificationResult
                                      .background_verification_spec
                                      .person_specification.full_title
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    backgroundVerificationResult.job_application
                                      .user.full_name
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    backgroundVerificationResult.background_verification_spec !==
                                      null
                                      ? backgroundVerificationResult
                                          .background_verification_spec.title
                                      : ""
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    backgroundVerificationResult
                                      .background_verification_spec
                                      .ifacts_check !== null
                                      ? backgroundVerificationResult
                                          .background_verification_spec
                                          .ifacts_check.title
                                      : ""
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    backgroundVerificationResult.background_verification_enquiry !==
                                      null
                                      ? backgroundVerificationResult
                                          .background_verification_enquiry
                                          .ifacts_enquiry_id
                                      : ""
                                  ) +
                                  "\n                            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    backgroundVerificationResult.result_text
                                  ) +
                                  "\n                                "
                              ),
                              backgroundVerificationResult.result !== null
                                ? _c("span", [
                                    _c("br"),
                                    _c("i", [
                                      _vm._v(
                                        _vm._s(
                                          backgroundVerificationResult.result
                                        )
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        backgroundVerificationResult.result,
                                      expression:
                                        "backgroundVerificationResult.result"
                                    }
                                  ],
                                  staticClass: "border-0",
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          backgroundVerificationResult,
                                          "result",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function($event) {
                                        return _vm.updateResultStatus(
                                          backgroundVerificationResult.id,
                                          backgroundVerificationResult.result
                                        )
                                      }
                                    ]
                                  }
                                },
                                [
                                  _c("option"),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "pass" } }, [
                                    _vm._v("Pass")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "fail" } }, [
                                    _vm._v("Fail")
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              backgroundVerificationResult.background_verification_enquiry !==
                                null &&
                              backgroundVerificationResult
                                .background_verification_enquiry
                                .attachment_path_cdn
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href:
                                          backgroundVerificationResult
                                            .background_verification_enquiry
                                            .attachment_path_cdn
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.sliceString(
                                            backgroundVerificationResult
                                              .background_verification_enquiry
                                              .attachment_path
                                          )
                                        ) +
                                          "\n                                    "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("Pagination", {
                    attrs: {
                      totalPages: _vm.totalPages,
                      currentPage: _vm.currentPage,
                      maxPagesToShow: 10
                    },
                    on: { "page-changed": _vm.handlePageChange }
                  })
                ],
                1
              )
            ]
          )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Requisition")]),
        _vm._v(" "),
        _c("th", [_vm._v("Person Specification")]),
        _vm._v(" "),
        _c("th", [_vm._v("Candidate Name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Verification Type")]),
        _vm._v(" "),
        _c("th", [_vm._v("iFact Check")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ifact Enquiry ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Manual Pass/ Fail Override")]),
        _vm._v(" "),
        _c("th", [_vm._v("Attachment")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04378f44", { render: render, staticRenderFns: staticRenderFns })
  }
}